<template>
  <v-expansion-panel>
    <v-expansion-panel-header>
      <h3 class="py-2 font-weight-bold">
        Mensagens
      </h3>
    </v-expansion-panel-header>

    <v-expansion-panel-content>
      <chat
        :ticket-id="ticketData.id"
        :solicitante-nome="ticketData.solicitante.nome"
        :solicitante-email="solicitanteEmail"
        :mensagens="mensagens"
        :template-whats-app24-horas-props="templateWhatsApp24HorasProps"
        :editavel="editavel"
        :pode-gravar-audio="podeGravarAudio"
        :ticket-esta-finalizado="ticketEstaFinalizado"
        :pode-responder-mensagem="podeResponderMensagem"
        @refetch-data="$emit('refetch-data')"
        @mensagem-adicionada="$emit('mensagem-adicionada')"
      />
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
import { computed } from '@vue/composition-api'
import Chat from '../mensagens/Chat.vue'

export default {
  components: {
    Chat,
  },

  props: {
    ticketData: {
      type: Object,
      required: true,
    },
    mensagens: {
      type: Array,
      required: true,
    },
    templateWhatsApp24HorasProps: {
      type: Object,
      required: true,
    },
    editavel: {
      type: Boolean,
      required: true,
    },
    ticketEstaFinalizado: {
      type: Boolean,
      required: true,
    },
    podeGravarAudio: {
      type: Boolean,
      required: true,
    },
    podeResponderMensagem: {
      type: Boolean,
      required: true,
    },
  },

  setup(props) {
    const solicitanteEmail = computed(() => props.ticketData.solicitante.contatos?.find(c => !!c.email)?.email)

    return {
      solicitanteEmail,
    }
  },
}
</script>
